function mmSlideProductReassurance() {
	var splideElemMain = document.querySelector('#slider-reassurance');
	// SLIDER PRODUCT
	if (splideElemMain) {
		var main = new Splide(splideElemMain, {
			type: 'loop',
			pagination: true,
			arrows: false,
			autoplay: true,
			interval: 5000,
			perPage: 1,
			gap: 2,
		});
		main.mount();
	}
}

// STICKY CTA DISPLAY ONLY WHEN SCROLL AFTER TRUE CTA
function initializeStickyCTA() {
	// if (window.innerWidth < 768) {
	let lastScrollPosition = 0;
	let isTicking = false;
	const classicCTA = document.querySelector('.mm-cta-wrapper');
	const stickyCTA = document.querySelector('.mm-main-product-button-container-sticky');

	if (!classicCTA || !stickyCTA) {
		console.log('CTA elements not found:', { classicCTA, stickyCTA });
		return;
	}

	function toggleStickyCTA() {
		const classicCTARect = classicCTA.getBoundingClientRect();
		const isClassicCTAInView = classicCTARect.top >= 0 && classicCTARect.bottom <= window.innerHeight;

		if (!isClassicCTAInView) {
			stickyCTA.classList.remove('mm-none');
		} else {
			stickyCTA.classList.add('mm-none');
		}
	}

	toggleStickyCTA();

	window.addEventListener('scroll', function () {
		lastScrollPosition = window.scrollY;
		if (!isTicking) {
			window.requestAnimationFrame(function () {
				toggleStickyCTA();
				isTicking = false;
			});
		}
		isTicking = true;
	});
	// }
}

/* Truncate Description */
function mmToggleDescr() {
	const trunDescriptions = document.querySelectorAll('.mm-truncate-descr');
	trunDescriptions.forEach(function (descr) {
		descr.classList.toggle('mm-none');
	});
}

function mmChangeQtty(delta, inputId) {
	const input = document.getElementById(inputId);
	if (delta == '-1' && input.value == '1') {
	} else {
		const newValue = parseInt(input.value, 10) + parseInt(delta, 10);
		input.value = newValue;
		mmUpdatePrice(newValue);
	}
}

function mmUpdatePrice(qtty) {
	const priceAll = document.querySelectorAll('.mm-product-price-all');
	priceAll.forEach(function (price) {
		price.innerHTML = ((price.dataset.value * qtty) / 100).toFixed(2) + '€';
	});
}
function handleDropdown() {
    // Select all the info product containers
    const infoProductContainers = document.querySelectorAll('.mm-pf-infos-product-container');

    // Open the first info product container by default and show limited content
    if (infoProductContainers.length > 0) {
        const firstInfoProduct = infoProductContainers[0];
        const dropdown = firstInfoProduct.querySelector('.mm-product-form-dropdown');
        const panel = firstInfoProduct.querySelector('.mm-pf-panel');
        const panelText = firstInfoProduct.querySelector('.mm-pf-panel-text');
        const moreLink = document.createElement('span');

        dropdown.classList.add('active');
        const icons = dropdown.querySelectorAll('.mm-pf-dropdown-icon');
        icons.forEach((icon) => {
            icon.classList.toggle('mm-none');
        });
        panel.style.maxHeight = panel.scrollHeight + 'px';

        // Create and insert the "en savoir plus" link
        moreLink.textContent = 'En savoir plus';
        moreLink.classList.add('mm-more-link');
        moreLink.style.cursor = 'pointer';

        // Limit the number of lines displayed initially
        panelText.style.display = '-webkit-box';
        panelText.style.webkitLineClamp = '4';
        panelText.style.webkitBoxOrient = 'vertical';
        panelText.style.overflow = 'hidden';

        panel.appendChild(moreLink); // Append the link after the panel text

        // Ensure the panel height is recalculated
        setTimeout(function () {
            panel.style.maxHeight = panel.scrollHeight + 'px';
        }, 0);

        moreLink.addEventListener('click', function () {
            panelText.style.display = 'block';
            panelText.style.webkitLineClamp = 'unset';
            panelText.style.overflow = 'visible';
            moreLink.style.display = 'none';
            panel.style.maxHeight = panel.scrollHeight + 'px'; // Adjust panel height after expanding content
        });
    }

    // Traitement de tous les éléments ayant la classe mm-pf-infos-product-container-see-more
    const seeMoreInfoProducts = document.querySelectorAll('.mm-pf-infos-product-container-see-more');
    seeMoreInfoProducts.forEach((seeMoreInfoProduct) => {
        const panel = seeMoreInfoProduct.querySelector('.mm-pf-panel');
        const panelText = seeMoreInfoProduct.querySelector('.mm-pf-panel-text');
        const seeMoreLink = document.createElement('span');

        seeMoreLink.textContent = 'En savoir plus';
        seeMoreLink.classList.add('mm-more-link');
        seeMoreLink.style.cursor = 'pointer';

        // Limit the number of lines displayed initially
        panelText.style.display = '-webkit-box';
        panelText.style.webkitLineClamp = '12';
        panelText.style.webkitBoxOrient = 'vertical';
        panelText.style.overflow = 'hidden';

        seeMoreLink.addEventListener('click', function () {
            panelText.style.display = 'block';
            panelText.style.webkitLineClamp = 'unset';
            panelText.style.overflow = 'visible';
            seeMoreLink.style.display = 'none';
            panel.style.maxHeight = panel.scrollHeight + 'px'; // Adjust panel height after expanding content
        });

        panel.appendChild(seeMoreLink); // Append the link after the panel text
    });

    // Add click event listeners to all dropdowns
    const acc = document.querySelectorAll('.mm-product-form-dropdown');
    acc.forEach((dropdown) => {
        dropdown.addEventListener('click', function () {
            const panel = this.nextElementSibling;
            const panelText = panel.querySelector('.mm-pf-panel-text');
            const moreLink = panel.querySelector('.mm-more-link');
            const hideTitle = panel.querySelector('.mm-pf-panel-text-hide-title');
            const hideList = panel.querySelector('.mm-pf-panel-text-hide-list');

            // arrow rotation
            this.classList.toggle('active');
            // changement de svg (+/-)
            const icons = this.querySelectorAll('.mm-pf-dropdown-icon');
            icons.forEach((icon) => {
                icon.classList.toggle('mm-none');
            });

            // Open or close the panel
            if (panel.style.maxHeight) {
                // If panel is open, close it but keep the "hide" sections' visibility intact
                panel.style.maxHeight = null;
            } else {
                // Open the panel and adjust its height
                panel.style.maxHeight = panel.scrollHeight + 'px';

                // Check if the hide section is already visible and adjust height accordingly
                if (hideList && hideList.style.display === 'block') {
                    panel.style.maxHeight = panel.scrollHeight + 'px';
                }
            }
        });
    });

    // Gestion du clic sur le titre pour afficher le contenu caché
    const hideTitles = document.querySelectorAll('.mm-pf-panel-text-hide-title');
    hideTitles.forEach((title) => {
        title.addEventListener('click', function () {
            const hideList = this.nextElementSibling; // Le texte caché se trouve juste après le titre
            if (hideList.style.display === 'none' || hideList.style.display === '') {
                hideList.style.display = 'block'; // Afficher le texte caché
            } else {
                hideList.style.display = 'none'; // Cacher à nouveau si déjà visible
            }

            // Ajuster la hauteur du panel pour refléter le contenu affiché
            const panel = this.closest('.mm-pf-panel');
            panel.style.maxHeight = panel.scrollHeight + 'px'; // Recalculer la hauteur du panel
        });
    });
}


// Add bundle
function mmAddBundleToCart(variantId) {
	const quantity = 1; // You can adjust quantity logic as needed
	const formData = new FormData();
	formData.append('id', variantId);
	formData.append('quantity', quantity);

	fetch('/cart/add.js', {
		method: 'POST',
		body: formData,
	})
	.then((response) => response.json())
	.then((data) => {
		// Handle success, maybe show a success message or redirect to the cart
		console.log('Added to cart:', data);
		// Example: redirect to the cart page
		window.location.href = '/cart';
	})
	.catch((error) => {
		console.error('Error adding to cart:', error);
		// Handle errors, show an error message to the user
	});
}

document.addEventListener('DOMContentLoaded', function () {
	handleDropdown();
	mmSlideProductReassurance();
	initializeStickyCTA();
});

class VariantSelector extends HTMLElement {
	constructor() {
		super();
		this.cached = {};
		this.container = this.closest('#product-form');
		this.addEventListener('change', this.onVariantChange.bind(this));
	}

	onVariantChange() {
		this.getSelectedOptions();
		this.getSelectedVariant();

		if (this.currentVariant) {
			this.updateURL();
			if (this.dataset.imageVariant) {
				this.updateImagesVariant();
			} else {
				this.updateMedia();
			}
			this.variantFetch();
		}
	}

	getSelectedOptions() {
		this.options = Array.from(
			this.querySelectorAll('.mm-product-variant-checkbox:checked'),
			(checkbox) => checkbox.value
		);
	}

	getVariantJSON() {
		this.variantData = JSON.parse(
			this.querySelector('[type="application/json"]').textContent
		);
		return this.variantData;
	}

	getSelectedVariant() {
		this.currentVariant = this.getVariantJSON().find((variant) => {
			const findings = !variant.options
				.map((option, index) => {
					return this.options[index] === option;
				})
				.includes(false);

			if (findings) return variant;
		});
	}

	updateURL() {
		window.history.replaceState(
			{},
			'',
			`${this.dataset.url}?variant=${this.currentVariant.id}`
		);
	}

	variantFetch() {
		const variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;

		if (this.cached[variantUrl]) {
			this.renderVariantInfo(this.cached[variantUrl]);
			return;
		}

		fetch(variantUrl)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, 'text/html');
				this.cached[variantUrl] = html;
				this.renderVariantInfo(html);
			})
			.catch((e) => {
				console.error(e);
			});
	}

	// Mise à jour des images des variants
	updateImagesVariant() {
		const allMainMedia = document.querySelectorAll(".main-slider-variant");
		allMainMedia.forEach((media) => {
			if (media.dataset.variantid == this.currentVariant.id) {
				media.style.display = "flex";
			} else {
				media.style.display = "none";
			}
		});
		const allThumbnailMedia = document.querySelectorAll(".thumbnail-slider-variant");
		allThumbnailMedia.forEach((media) => {
			if (media.dataset.variantid == this.currentVariant.id) {
				media.style.display = "flex";
			} else {
				media.style.display = "none";
			}
		});
	}

	// Update media en fonction du variant sélectionné si pas de slider thumbnail
	updateMedia() {
		if (this.currentVariant.featured_media != null) {
			const allMainMedia = document.querySelectorAll(".mm-product-medias .splide__slide");
			const variant_media_id = this.currentVariant.featured_media.id;
			allMainMedia.forEach((media) => {
				if (media.dataset.id != null && parseInt(media.dataset.id) == variant_media_id) {
					const pagination = document.querySelectorAll(".mm-product-medias .splide__pagination li")[parseInt(media.dataset.index)];
					pagination.querySelector("button").click();
				}
			});
		}
	}

	renderVariantInfo(html) {
		this.updateElementOuter('#mmProductFormSelectedVariantId', html);
		this.updateElementOuter('.mm-main-product-CTA-container', html);
		this.updateElementOuter('#mm-main-price-container', html);
		this.updateElementOuter('.mm-product-price', html);
		this.updateElementOuter('.mm-reduce-price', html);
		this.updateElementOuter('.mm-media-container', html);
		this.updateElementOuter('.mm-paiement-text', html);
    this.updateElementOuter('.mm-main-product-button-container-sticky .mm-main-product-button-container', html);
    initializeStickyCTA();  // Re-initialize the sticky CTA here

	}

	/**
	 *
	 * @param {string} selector
	 * @param {HtmlElement} html
	 */
	updateElement(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.innerHTML = source.innerHTML;
	}

	updateElementOuter(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.outerHTML = source.outerHTML;
	}
}
customElements.define('variant-selector', VariantSelector);
